import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import { Navigate, Outlet } from "react-router-dom";
import Footer from "../components/Layout/Footer";
import Navbar from "../components/Layout/Navbar";
import Sidebar from "../components/Layout/Sidebar";
import { useEffect, useState } from "react";
import { useUserContext } from "../context/users/users";
import { BackgroundJobProvider } from "../context/BackgroundJobContext";
import JobProgressWidget from "../components/Backup/JobProgressWidget";

const MainLayout = () => {
  const { loggedin_user_detail } = useUserContext();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const apiToken = localStorage.getItem("api_token");
    if (!apiToken) {
      setIsAuthenticated(false);
    } else {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, [loggedin_user_detail]);

  if (isLoading) {
    return null; // Or a loading spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <BackgroundJobProvider>
      <Layout className="min-h-screen">
        <Sidebar />
        <Layout>
          <Navbar />
          <Content className="bg-gray-50 p-4">
            <Outlet />
          </Content>
          <Footer />
        </Layout>
      </Layout>
      <JobProgressWidget />
    </BackgroundJobProvider>
  );
};

export default MainLayout;
